import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { ApolloQueryResult } from 'apollo-client';
import { ME_QUERY } from '../../gql/queries/user.query';
import { MeResponseModel } from '../models/user-me.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private apollo: Apollo) {}

  getMe(): Observable<ApolloQueryResult<MeResponseModel>> {
    return this.apollo.query<MeResponseModel>({
      query: ME_QUERY
    });
  }
}
